<template>
  <div>
<!--    <div v-if="settings.theme.input.sublabel" class="text-body2" v-html="field.label"></div>-->
    <q-field
        borderless
        v-model="fieldValue"
        :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
    >
      <template v-slot:control>
    <q-option-group
        :options="optionsForSelect"
        type="radio"
        v-model="fieldValue"
        debounce="500"
    />
      </template>
    </q-field>
<!--    <div class="text-caption" v-html="field.description"></div>-->
  </div>


</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      value: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      updateFieldValueByFieldType: 'values/list/updateFieldValueByFieldType'
    })
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      if(this.field.settings_enabled && this.field.settings && this.field.settings.options) {
        for (const [key, value] of Object.entries(this.field.settings.options)) {
          data.push( {
            label: value.label,
            value: value.value,
            key: key
          });
        }
      } else {
        for (const [key, value] of Object.entries(this.field.options)) {
          data.push( {
            label: value,
            value: key
          });
        }
      }

      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue ? this.modelValue : null
      },
      set(value) {
        //console.log(value);
        this.$emit('update:modelValue', value);
        const values = {
          "Purchase": "Purchase",
          "Pre-qualification": "Purchase",
          "Refinance": "Refinance",
          "Refinance to Obtain Cash": "Refinance",
          "Home Equity": "Refinance"
        };
        if({}.hasOwnProperty.call(values, value)) {
          this.updateFieldValueByFieldType({form: this.form, type: 'loan.purpose', fieldValue: values[value]});
        }
      },
    }
  },
  mounted() {

  }
}
</script>
